module.exports = __webpack_public_path__ + "media/chamkraburng.f1b81aed.mp3";